module.exports = __webpack_public_path__ + "img/norm-6.1a6725e.png";